import * as t from 'io-ts'

const validFileTypeToNull = {
  'application/json': null,
  'application/pdf': null,
  'image/bmp': null,
  'image/gif': null,
  'image/jpeg': null,
  'image/png': null,
  'image/tiff': null,
  'image/webp': null,
  'text/csv': null,
  'text/plain': null,
  'text/rtf': null,
  'text/tab-separated-values': null,
  'application/zip':null
}

export const ValidFileTypeIO = t.keyof(validFileTypeToNull)

export type ValidFileTypeT = t.TypeOf<typeof ValidFileTypeIO>

export const validFileTypes = Object.keys(
  validFileTypeToNull,
) as ValidFileTypeT[]


